// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1FfjQ","list":"BalanceDue_list__1QDYJ","listRow":"BalanceDue_listRow__8PX8-","total":"BalanceDue_total__AJ5Pu"};